/* 🤖 this file was generated by svg-to-ts */
export const iccIconCheckBoxChecked: {
  name: 'check_box_checked';
  data: string;
} = {
  name: 'check_box_checked',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 16H5V5h14v14Z" fill="currentColor"/><path d="m17.99 9-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99 8-8Z" fill="currentColor"/></svg>`
};
